import styled from 'styled-components';

// layout colors
import blueGrey300Color from '../../../../layout/colors/blueGrey300.color.layout';

const Attribute = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;

  & i {
    font-size: 1.2rem;
    color: ${blueGrey300Color};
  }
`;

export default Attribute;
